import jwtDecode from 'jwt-decode';


export function parseJwt(token) {
    return jwtDecode(token);
};

export function convertDate(str) {
    let date = new Date(str);
    date = date.toLocaleString("en-IN", {
        day: "2-digit",
        month: "short",
        year: 'numeric',
        hour: "2-digit",
        minute: "2-digit",
    });
    return date;
};

export function capitalizeOnlyFirstLetter(str) {
    str = str.toLowerCase();
    const arrOfWords = str.split(" ");
    const arrOfWordsCased = [];
  
    for (let i = 0; i < arrOfWords.length; i++) {
      const char = arrOfWords[i].split("");
      char[0] = char[0].toUpperCase();
  
      arrOfWordsCased.push(char.join(""));
    }
    return arrOfWordsCased.join(" ");
  }

  export const exportCSVFile = function (headers, items, fileTitle) {
    if (headers) {
      items.unshift(headers);
    }
    var jsonObject = JSON.stringify(items);
    var csv = convertToCSV(jsonObject);
    var exportedFilenmae = fileTitle + ".csv" || "export.csv";
    var blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    if (navigator.msSaveBlob) {
      // IE 10+
      navigator.msSaveBlob(blob, exportedFilenmae);
    } else {
      var link = document.createElement("a");
      if (link.download !== undefined) {
        // feature detection
        var url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", exportedFilenmae);
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  };
  
  /* Converting to CSV format */
  const convertToCSV = function (objArray) {
    var array = typeof objArray != "object" ? JSON.parse(objArray) : objArray;
    var str = "";
    for (var i = 0; i < array.length; i++) {
      var line = "";
      for (var index in array[i]) {
        if (line !== "") line += ",";
        line += array[i][index];
      }
      str += line + "\r\n";
    }
    return str;
  };